export const Questions = [{
        questionText: 'What is the capital of France?',
        answerOptions: [
            { answerText: 'New York', isCorrect: false },
            { answerText: 'London', isCorrect: false },
            { answerText: 'Paris', isCorrect: true },
            { answerText: 'Dublin', isCorrect: false },
        ],
    },
    {
        questionText: 'Who is CEO of Tesla?',
        answerOptions: [
            { answerText: 'Jeff Bezos', isCorrect: false },
            { answerText: 'Elon Musk', isCorrect: true },
            { answerText: 'Bill Gates', isCorrect: false },
            { answerText: 'Tony Stark', isCorrect: false },
        ],
    },
    {
        questionText: 'The iPhone was created by which company?',
        answerOptions: [
            { answerText: 'Apple', isCorrect: true },
            { answerText: 'Intel', isCorrect: false },
            { answerText: 'Amazon', isCorrect: false },
            { answerText: 'Microsoft', isCorrect: false },
        ],
    },
    {
        questionText: 'How many Harry Potter books are there?',
        answerOptions: [
            { answerText: '1', isCorrect: false },
            { answerText: '4', isCorrect: false },
            { answerText: '6', isCorrect: false },
            { answerText: '7', isCorrect: true },
        ],
    },



    {
        questionText: 'Which language runs in a web browser?',
        answerOptions: [
            { answerText: 'Python', isCorrect: false },
            { answerText: 'C++', isCorrect: false },
            { answerText: 'C', isCorrect: false },
            { answerText: 'Java', isCorrect: true },
        ],
    },


    {
        questionText: 'What does CSS stand for?',
        answerOptions: [
            { answerText: 'Central Style Sheets', isCorrect: false },
            { answerText: 'Cascading Style Sheets', isCorrect: true },
            { answerText: 'Cascading Simple Sheets', isCorrect: false },
            { answerText: 'Cars SUVs Sailboats', isCorrect: false },
        ],
    },





    {
        questionText: 'What year was JavaScript launched?',
        answerOptions: [
            { answerText: '1996', isCorrect: true },
            { answerText: '1995', isCorrect: false },
            { answerText: '1994', isCorrect: false },
            { answerText: ' None of the above', isCorrect: false },
        ],
    },







    {
        questionText: 'What does HTML stand for?',
        answerOptions: [
            { answerText: 'Hypertext Markup Language', isCorrect: true },
            { answerText: 'Hypertext Markdown Language', isCorrect: false },
            { answerText: 'Hyperloop Machine Language', isCorrect: false },
            { answerText: 'Helicopters Terminals Motorboats Lamborginis', isCorrect: false },
        ],
    },








]